import React, { lazy, memo, useMemo } from "react";
import { Box, Button, Card, IconButton, Typography } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { Close } from "@material-ui/icons";
import { orderBy } from "lodash";
const EditStrength = lazy(() => import("../../EditStrength"));

const ListStrengths = () => {
  const { watch, setValue } = useFormContext();
  const { addStrength, listOfStrength, removedStrength } = watch(
    "configuration.strengths"
  );
  const removeFromList = (idx) => {
    setValue("configuration.strengths", {
      removedStrength: [
        ...removedStrength,
        { ...listOfStrength?.[idx], action: "remove" },
      ].filter((res) => res?.id),
      listOfStrength: listOfStrength.filter((_, index) => index !== idx),
      addStrength,
    });
  };

  const displayList = useMemo(
    () => (
      <Box mt={2}>
        <Typography variant="subtitle2" className="font-semibold font-14">
          Added strengths ({listOfStrength?.length})
        </Typography>
        {listOfStrength?.map((res, index) => (
          <Box
            className="border rounded"
            p={2}
            mt={0.5}
            mb={1}
            display={"flex"}
            justifyContent={"center"}
            alignItems="flex-start"
          >
            <EditStrength
              name={`configuration.strengths.listOfStrength`}
              index={index}
              data={res}
            />
            <IconButton
              onClick={() => removeFromList(index)}
              data-testid="remove-btn"
              size="small"
              className="remove-btn"
            >
              <Close fontSize="small"></Close>
            </IconButton>
          </Box>
        ))}
      </Box>
    ),
    [listOfStrength?.length]
  );
  return <Box>{listOfStrength?.length ? displayList : null}</Box>;
};

export default memo(ListStrengths);
